var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.siteTour'] = (function () {
    'use strict';

    const CONFIG = {
        COOKIE_NAME: "FinancialCenterFirstCU_SiteTour",
        COOKIE_VALUE: "Closed"
    };

    const initialize = (widget) => {

        const carouselEl = widget.querySelector(".splide");
        if (carouselEl) carousel(carouselEl);

        const modal = widget.closest(".modal");
        if (modal) bindModalCloseButton(modal);
        
    }

    const bindModalCloseButton = (modal) => {
        const modalCloseButtons = modal.querySelectorAll("button[data-bs-dismiss='modal']");
        modalCloseButtons.forEach(button => {
            button.addEventListener("click", function () {
                App.Cookies.setItem(CONFIG.COOKIE_NAME, CONFIG.COOKIE_VALUE, Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            });
        });
    }

    const carousel = (carousel) => {

        const splideOptions = {
            pagination: false,
            breakpoints: {
                991: {
                    destroy: true,
                },
            }
        };

        App.Helpers.splideFallback(
            carousel,
            splideOptions,
            function (splide) {
                splideEventBindings(splide, carousel);
            }
        );
    }

    const splideEventBindings = (splide, carousel) => {

        const splideButtons = carousel.querySelectorAll("button[data-slide]");
        const current = carousel.querySelector(".splide__status-current");
        const count = carousel.querySelector(".splide__status-count");

        const updateStatus = function () {
            current.textContent = splide.index + 1;
            count.textContent = splide.Components.Controller.getEnd() + 1;
        };

        splide.on('mounted move', updateStatus);

        // bound once (previously re-bound on every move, stacking duplicate handlers)
        splideButtons.forEach(button => {
            button.addEventListener("click", function () {
                handleSplideButton(button, splide);
            });
        });
    }

    // the button that was pressed sits in a slide that is now hidden, so move focus to the slide shown (WCAG 2.4.3)
    const focusActiveSlide = (splide) => {
        const slide = splide.Components.Slides.getAt(splide.index)?.slide;
        if (!slide) return;

        slide.setAttribute("tabindex", "-1");
        slide.focus({ preventScroll: true });
    };

    const handleSplideButton = (button, splide) => {

        const whichSlide = parseInt(button.getAttribute("data-slide"));
        const isSplide = button.closest(".splide")?.classList.contains("splide--slide");

        if (isSplide) {
            splide.go(whichSlide);
            focusActiveSlide(splide);
        }
        else {
            const modal = button.closest(".modal");
            const target = modal ? modal : window;
            const slide = (modal ? modal : document).querySelector(`.slide:nth-child(${whichSlide + 1})`);
            const height = slide ? slide.offsetTop : 0;

            target.scrollTo({
                top: height,
                behavior: "smooth"
            });
        }

    };

    return {
        initialize
    };

})();
